import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetInternalJobsPublicQuery } from '../../../../redux/services/fij_internal_jobs.jsx';
import CollapseBlock from '../../../common/blocks/CollapseBlock/CollapseBlock.jsx';
import Spinner from '../../../common/spinner/Spinner.jsx';
import { MainTitle } from '../../../common/index.jsx';
import FIJobsTable from '../../CMSPages/FriInternalJobs/FijJobs/FijJobsPage/FijJobsTable.jsx';
import { Alert } from 'antd';

const FijJobsPage = () => {
  const { t } = useTranslation();
  const { data: internalJobs, isLoading } = useGetInternalJobsPublicQuery();

  return (
    <>
      <MainTitle title={t('FRI.prax')} />

      <div style={{ marginBottom: 12 }}>
        <Alert
          type="info"
          showIcon
          description={
            <span>
              {t(
                'Na vypísanie FRI praxe (učitelia) alebo prihlásenie na FRI prax (študenti) je potrebné ',
              )}
              <a href="/cms/fri-internal-jobs/jobs">
                {t('prejsť do portálu FRI')}
              </a>
              .
            </span>
          }
        />
      </div>

      <CollapseBlock title={t('Zoznam aktuálnych FRI praxí')}>
        {isLoading ? (
          <Spinner />
        ) : (
          <FIJobsTable
            internalJobs={internalJobs || []}
            fromPublic={true}
            user={undefined}
            onApproveClick={() => {}}
            onRejectClick={() => {}}
            onArchiveClick={() => {}}
            onDeleteClick={() => {}}
            onDeleteInterestClick={() => {}}
          />
        )}
      </CollapseBlock>
    </>
  );
};

export default FijJobsPage;
